$(function () {
  $('.color_picker').colorpicker();
});
